var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelances(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3098 2.33367V7.33367M18.3098 7.33367H13.3098M18.3098 7.33367L14.4515 3.70034C13.302 2.55012 11.8098 1.80466 10.1998 1.57629C8.58974 1.34792 6.9491 1.64902 5.52509 2.4342C4.10108 3.21939 2.97084 4.44613 2.30468 5.92956C1.63853 7.41299 1.47255 9.07275 1.83177 10.6587C2.19098 12.2447 3.05593 13.6709 4.29626 14.7226C5.53659 15.7742 7.08511 16.3942 8.70848 16.4892C10.3318 16.5841 11.9421 16.1489 13.2966 15.2491C14.6511 14.3493 15.6764 13.0336 16.2181 11.5003",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelances);
export default __webpack_public_path__ + "static/media/relances.fe32bfe8c3f23ed88505d9711d250e57.svg";
export { ForwardRef as ReactComponent };